import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import PageLayout from "@/components/layout/PageLayout";
import { SidebarProvider } from "@/components/ui/sidebar";
import { DashboardSidebar } from "@/components/dashboard/DashboardSidebar";
import { PaymentsContainer } from "@/components/dashboard/payments/PaymentsContainer";
import { DashboardPromotionalCards } from "@/components/dashboard/DashboardPromotionalCards";

const PaymentsPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState<string | null>(null);

  useEffect(() => {
    const init = async () => {
      const { data: session } = await supabase.auth.getSession();
      
      if (!session.session) {
        navigate("/auth");
        return;
      }

      setUserId(session.session.user.id);
      setLoading(false);
    };

    init();
  }, [navigate]);

  if (loading) {
    return (
      <PageLayout>
        <div className="container mx-auto py-8">
          <p>Loading...</p>
        </div>
      </PageLayout>
    );
  }

  return (
    <PageLayout showBreadcrumbs={false}>
      <SidebarProvider>
        <div className="flex min-h-screen w-full">
          <DashboardSidebar />
          <div className="flex-1">
            <div className="container mx-auto py-8">
              <div className="space-y-6">
                <h1 className="text-2xl font-bold">Payments</h1>
                {userId && <PaymentsContainer userId={userId} />}
                <DashboardPromotionalCards />
              </div>
            </div>
          </div>
        </div>
      </SidebarProvider>
    </PageLayout>
  );
};

export default PaymentsPage;